// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3iiYT","errorLogs":"styles_errorLogs__1Tqmp"};